import { useState } from 'react'
import moment from 'moment'
import ReactDOM from 'react-dom'
import { isWithinAcceptableRange } from '../../../../infrastructure/date'

export function useDatePickerState(date: string | null, setDate: (newDate: String | null) => void, onError?: boolean) {
    let [isOnError, setIsOnError] = useState<boolean>(!!onError)

    function onChange(newDate: moment.Moment | null) {
        let newState = {
            date: null as string | null,
            isOnError: false
        }

        if (newDate !== null) {
            if (!newDate.isValid())
                newState.isOnError = true
            else {
                newState.isOnError = !isWithinAcceptableRange(newDate)
                newState.date = newDate.utc(true).toISOString()
            }
        }

        ReactDOM.unstable_batchedUpdates(() => {
            setDate(newState.date ?? date)
            setIsOnError(newState.isOnError)
        })
    }

    return { isOnError, setIsOnError, onChange }
}